import type { QueryClient } from '@tanstack/react-query';
import type { AppDispatch } from '../store/index.ts';
import { resetAuth, resetFilters, resetUI } from '../store/index.ts';

export function resetAllState(dispatch: AppDispatch, queryClient: QueryClient) {
  // 1. Clear Redux store — reset every slice to initialState
  dispatch(resetAuth());
  dispatch(resetUI());
  dispatch(resetFilters());

  // 2. Clear entire TanStack Query cache — removes all in-memory server data
  queryClient.clear();

  // 3. Clear localStorage — removes persisted auth token and session
  localStorage.removeItem('vardaan_auth_token');
  localStorage.removeItem('vardaan_user');

  // 4. Cancel any in-flight queries — prevents stale data arriving after logout
  queryClient.cancelQueries();
}
